import {Api, ApiExport} from '../../../Api.js'

const RESOURCE = 'order'

export default {
    resource: RESOURCE,
    prefix: 'shop/',
    export(query, filename) {
        /*
        return window.axios({
            url: window.axios.defaults.baseURL + '/' + this.prefix + this.resource + '/export' + (query ? query : ''),
            method: 'GET',
            responseType: 'blob', // important
        });
        */
        return ApiExport(filename).get(this.prefix + this.resource + '/export' + (query ? query : ''),
            {
                responseType: 'blob', // important
            });
    },
    exportInvoices(query, filename) {
        /*
        return window.axios({
            url: window.axios.defaults.baseURL + '/' + this.prefix + this.resource + '/export' + (query ? query : ''),
            method: 'GET',
            responseType: 'blob', // important
        });
        */
        return ApiExport(filename).get(this.prefix + this.resource + '/export-invoices' + (query ? query : ''),
            {
                responseType: 'blob', // important
            });
    },
    query(query) {
        return Api().get(this.prefix + this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.prefix + this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.prefix + this.resource, data)
    },
    update(id, data) {
        return Api().put(this.prefix + this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.prefix + this.resource + '/' + id)
    },
    unsetReadonly(id) {
        return Api().get(this.prefix + this.resource + '/unlock/'  + id )
    },
    duplicate(id) {
        return Api().get(this.prefix + this.resource + '/duplicate/' + id)
    },
    getStatsBestsellers(period){
        return Api().get(this.prefix + this.resource + '/stats/bestsellers?period=' + period)
    },
    getStats(period, date = null) {

        if(date) {
            return Api().get(this.prefix + this.resource + '/stats?period=' + period + '&date=' + date);
        }

        return Api().get(this.prefix + this.resource + '/stats?period=' + period )
    },
    getStatsResume(period, date = null) {

        if(date) {
            return Api().get(this.prefix + this.resource + '/stats/resume?period=' + period + '&date=' + date);
        }

        return Api().get(this.prefix + this.resource + '/stats/resume?period=' + period )
    },
    getCustomersByLanguage(period,date=null) {
        return Api().get(this.prefix + this.resource + '/stats/customers?period=' + period + '&date=' + date);
    },
    setMultipleStatus(data) {
        return Api().post(this.prefix + this.resource + '/multiple/edit', data)
    },
    calculate(data) {
        return Api().post(this.prefix + this.resource + '/calculate', data)
    },
    getOrderCredit(person_id) {
        return Api().get(this.prefix + this.resource + '/credit/' + person_id );
    },
    getOrderByCustomer(person_id) {
        return Api().get(this.prefix + this.resource + '/customer/' + person_id );
    }
}


// WEBPACK FOOTER //
// ./src/modules/shop/order/OrderService.js